'use client';

import React, { useState } from 'react';
import { Stethoscope, Syringe, Pill } from 'lucide-react';
import HealthSummaryCards from './HealthSummaryCards';
import HealthRecordsTab from './HealthRecordsTab';
import VaccinationTab from './VaccinationTab';
import MedicationTab from './MedicationTab';
import Icon from '@/components/ui/AppIcon';


const TABS = [
  { id: 'health', label: 'Health Records', icon: Stethoscope },
  { id: 'vaccination', label: 'Vaccination Schedules', icon: Syringe },
  { id: 'medication', label: 'Medication Tracking', icon: Pill },
];

export default function HealthContent() {
  const [activeTab, setActiveTab] = useState('health');

  return (
    <div className="p-6">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Health & Vaccination</h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage flock health records, vaccination schedules with due-date alerts, and medication tracking linked to inventory.
        </p>
      </div>

      {/* Summary Cards */}
      <HealthSummaryCards />

      {/* Tabs */}
      <div className="flex gap-1 mb-6 bg-gray-100 p-1 rounded-xl w-fit">
        {TABS?.map(tab => {
          const Icon = tab?.icon;
          const isActive = activeTab === tab?.id;
          return (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-150 ${
                isActive ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon size={15} />
              {tab?.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      {activeTab === 'health' && <HealthRecordsTab />}
      {activeTab === 'vaccination' && <VaccinationTab />}
      {activeTab === 'medication' && <MedicationTab />}
    </div>
  );
}
